import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import storeService from '../../services/storeService';

const DEFAULT_SETTINGS = {
  autoPrint: true,
  printLogo: true,
  printStoreName: true,
  printQrCode: 'Membership',
  qrCodeNotice: 'Thank you for shopping! Scan to Join Membership',
  footerText: '',
  additionalText: '',
};

const PrintingSettings = () => {
  const [settings, setSettings] = useState({ ...DEFAULT_SETTINGS });
  const [isLoading, setIsLoading] = useState(true);
  const [success, setSuccess] = useState('');
  const { id: storeId } = useParams();

  useEffect(() => {
    storeService.getStoreById(storeId).then(data => {
      if (data.receiptSettings) {
        const existing = data.receiptSettings;
        const footerText = existing.footerText ?? existing.additionalText ?? DEFAULT_SETTINGS.footerText;
        setSettings({
          ...DEFAULT_SETTINGS,
          ...existing,
          footerText,
          additionalText: existing.additionalText ?? footerText,
        });
      } else {
        setSettings({ ...DEFAULT_SETTINGS });
      }
      setIsLoading(false);
    });
  }, [storeId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings(prev => {
      const nextValue = type === 'checkbox' ? checked : value;
      if (name === 'footerText') {
        return { ...prev, footerText: nextValue, additionalText: nextValue };
      }
      return { ...prev, [name]: nextValue };
    });
  };

  const handleSave = async () => {
    const payload = {
      ...settings,
      additionalText: settings.footerText,
    };
    await storeService.updateStore(storeId, { receiptSettings: payload });
    setSuccess('Printing settings saved successfully!');
    setTimeout(() => setSuccess(''), 3000);
  };

  if (isLoading) return <div>Loading...</div>;

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Receipt Printing Settings</h2>
      {success && <p className="bg-green-100 text-green-700 p-3 rounded mb-4">{success}</p>}
      <div className="space-y-6">
        <div className="flex items-center justify-between p-3 border rounded-md"><label htmlFor="autoPrint" className="text-gray-700">Auto Print Receipt</label><input id="autoPrint" type="checkbox" name="autoPrint" checked={settings.autoPrint} onChange={handleChange} className="toggle-checkbox" /></div>
        <div className="flex items-center justify-between p-3 border rounded-md"><label htmlFor="printLogo" className="text-gray-700">Print Store Logo</label><input id="printLogo" type="checkbox" name="printLogo" checked={settings.printLogo} onChange={handleChange} /></div>
        <div className="flex items-center justify-between p-3 border rounded-md"><label htmlFor="printStoreName" className="text-gray-700">Print Store Name</label><input id="printStoreName" type="checkbox" name="printStoreName" checked={settings.printStoreName} onChange={handleChange} /></div>
        <div><label className="block text-sm font-medium text-gray-700">Print QR Code</label><select name="printQrCode" value={settings.printQrCode} onChange={handleChange} className="mt-1 w-full p-2 border rounded-md"><option value="Disabled">Disabled</option><option value="Membership">Membership</option><option value="OnlineOrdering">Online Ordering</option></select></div>
        <div><label className="block text-sm font-medium text-gray-700">QR Code Message</label><input name="qrCodeNotice" value={settings.qrCodeNotice} onChange={handleChange} className="mt-1 w-full p-2 border rounded-md" /></div>
        <div><label className="block text-sm font-medium text-gray-700">Footer Text</label><textarea name="footerText" value={settings.footerText} onChange={handleChange} rows="3" className="mt-1 w-full p-2 border rounded-md"></textarea></div>
      </div>
      <div className="flex justify-end mt-6">
        <button onClick={handleSave} className="bg-primary text-white px-6 py-2 rounded-md">Save Settings</button>
      </div>
    </div>
  );
};

export default PrintingSettings;
